export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

// INFO: any-ascii is heavy, so it is loaded only when needed
export const transliterate = async (string: string) => {
  try {
    const { default: anyAscii } = await import('any-ascii');

    return anyAscii(string);
  } catch {
    return string;
  }
};
